// extracted by mini-css-extract-plugin
export default {"sliderBtn":"SliderButton_sliderBtn__w6DtP"};